import logoWhite from "@/assets/logo-white.webp.asset.json";
import logoBleu from "@/assets/logo-bleu.png.asset.json";
import { Link } from "@tanstack/react-router";

type Variant = "bleu" | "white";

interface LogoProps {
  variant?: Variant;
  height?: number;
  className?: string;
  withLink?: boolean;
  ariaLabel?: string;
}

const sources: Record<Variant, string> = {
  bleu: logoBleu.url,
  white: logoWhite.url,
};

export function Logo({
  variant = "bleu",
  height,
  className = "",
  withLink = true,
  ariaLabel = "Berk Hospitality Group",
}: LogoProps) {
  const style = height !== undefined
    ? { height, width: "auto", display: "block" as const, flexShrink: 0 }
    : { display: "block" as const, flexShrink: 0 };
  const img = (
    <img
      src={sources[variant]}
      alt={ariaLabel}
      width={843}
      height={249}
      loading={variant === "white" ? "lazy" : "eager"}
      decoding="async"
      style={style}
      className={className}
    />
  );
  if (!withLink) return img;
  return (
    <Link to="/" aria-label={ariaLabel} className="inline-flex shrink-0 items-center">
      {img}
    </Link>
  );
}
